import { render, staticRenderFns } from "./ProfileLocations.vue?vue&type=template&id=1fac464b&scoped=true"
import script from "./ProfileLocations.vue?vue&type=script&lang=js"
export * from "./ProfileLocations.vue?vue&type=script&lang=js"
import style0 from "./ProfileLocations.vue?vue&type=style&index=0&id=1fac464b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fac464b",
  null
  
)

export default component.exports